import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetopunecab() {



  const cardData = {


  keyword: "Thane to Pune Cabs",

  headingDescription: "Trustline Cab provides reliable Thane to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, industrial visits, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Thane to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Thane to Pune taxi services.",

  topPlaces: [
    {
      title: "Hadapsar",
      description: "Hadapsar is one of Pune's largest commercial destinations, home to Magarpatta City, IT parks, corporate offices, educational institutions, shopping malls, and modern residential communities. It is a preferred location for professionals and business travelers."
    },
    {
      title: "Tathawade",
      description: "Tathawade is a rapidly developing suburb featuring educational institutions, commercial developments, premium residential projects, and excellent connectivity to Wakad, Hinjewadi, and Pimpri Chinchwad."
    },
    {
      title: "Kondhwa",
      description: "Kondhwa is a well-established residential and commercial locality known for business centers, hospitals, educational institutions, shopping complexes, and excellent road connectivity across Pune."
    },
    {
      title: "Ranjangaon MIDC",
      description: "Ranjangaon MIDC is one of Maharashtra's leading industrial zones, housing automobile manufacturers, engineering industries, pharmaceutical companies, and logistics hubs. It is a major destination for industrial and corporate travel."
    },
    {
      title: "Pune Railway Station",
      description: "Pune Railway Station is one of the city's busiest transport hubs, providing excellent rail connectivity across India. It is a convenient destination for passengers requiring reliable cab services."
    },
    {
      title: "Balewadi High Street",
      description: "Balewadi High Street is a popular lifestyle and commercial destination offering premium restaurants, cafés, offices, retail outlets, and entertainment venues. It attracts professionals and families throughout the year."
    },
    {
      title: "Shinde Chhatri",
      description: "Shinde Chhatri is a magnificent historical monument known for its elegant architecture, beautiful carvings, and cultural significance. It is a popular sightseeing destination in Pune."
    },
    {
      title: "Pune Okayama Friendship Garden",
      description: "Pune Okayama Friendship Garden is a beautifully landscaped Japanese-style garden featuring peaceful walking paths, lush greenery, and scenic views. It is one of Pune's most relaxing tourist attractions."
    },
    {
      title: "Pawna Lake",
      description: "Pawna Lake is a scenic getaway near Pune, famous for lakeside camping, boating, mountain views, and peaceful surroundings. It is a favorite destination for weekend trips and outdoor activities."
    },
    {
      title: "Visapur Fort",
      description: "Visapur Fort is a historic hill fort near Lonavala, known for its trekking trails, breathtaking valley views, waterfalls during the monsoon, and rich Maratha heritage. It is a popular attraction for adventure lovers."
    }
  ],






"services": [
  {
    "name": "Thane to Pune Cab",
    "description": "Book Thane to Pune Cab for safe and comfortable intercity travel with experienced chauffeurs, clean AC Sedan, Ertiga, Innova, and Innova Crysta vehicles. Enjoy fixed fares, doorstep pickup, online booking, luggage assistance, one way and round trip options, corporate travel, family trips, and reliable 24x7 customer support."
  },
  {
    "name": "Thane to Pune Taxi",
    "description": "Choose Thane to Pune Taxi for convenient outstation travel with professional drivers, sanitized vehicles, transparent pricing, flexible pickup timings, airport transfers, business travel, family vacations, and comfortable highway journeys."
  },
  {
    "name": "Thane to Pune Station Cab Fare",
    "description": "Check Thane to Pune Station Cab Fare with affordable pricing, fixed packages, multiple vehicle choices, and comfortable transportation for railway station pickups and drops."
  },
  {
    "name": "Thane to Pune One Way Cab",
    "description": "Book Thane to Pune One Way Cab with instant confirmation, AC vehicles, professional chauffeurs, transparent pricing, and reliable doorstep pickup for hassle-free travel."
  },
  {
    "name": "Thane to Pune Ertiga Cab",
    "description": "Reserve Thane to Pune Ertiga Cab for spacious six-seater travel, family trips, airport transfers, corporate journeys, and comfortable outstation transportation."
  },
  {
    "name": "Thane to Pune One Way Taxi",
    "description": "Travel with Thane to Pune One Way Taxi offering affordable fares, clean vehicles, experienced drivers, luggage assistance, and safe intercity transportation."
  },
  {
    "name": "Thane to Pimpri Chinchwad Cab Fare",
    "description": "Find Thane to Pimpri Chinchwad Cab Fare with fixed rates, AC vehicles, professional drivers, and reliable outstation cab services."
  },
  {
    "name": "Thane to Pune Cab Service",
    "description": "Our Thane to Pune Cab Service provides Sedan, Ertiga, Innova Crysta, and SUV vehicles with fixed pricing, doorstep pickup, experienced chauffeurs, and 24x7 customer assistance."
  },
  {
    "name": "Thane to Pune Innova Cab Service",
    "description": "Book Thane to Pune Innova Cab Service for group travel, corporate trips, airport transfers, family vacations, spacious seating, and premium comfort."
  },
  {
    "name": "Mulund to Pune Taxi Fare",
    "description": "Check Mulund to Pune Taxi Fare with transparent pricing, affordable packages, AC vehicles, and professional chauffeur-driven cab services."
  },
  {
    "name": "Cab Service in Thane",
    "description": "Hire Cab Service in Thane for local and outstation travel with experienced drivers, well-maintained vehicles, online booking, and dependable customer support."
  },
  {
    "name": "Thane to Pune Round Trip Cab Service",
    "description": "Book Thane to Pune Round Trip Cab Service with flexible return schedules, fixed fares, premium vehicles, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Thane to Baner Cab Fare",
    "description": "Check Thane to Baner Cab Fare with affordable pricing, comfortable AC cars, professional drivers, and safe highway travel."
  },
  {
    "name": "Outstation Taxi Service in Thane",
    "description": "Choose Outstation Taxi Service in Thane for one way, round trip, airport transfers, and business travel with transparent pricing and clean AC vehicles."
  },
  {
    "name": "Best Outstation Taxi Service in Thane",
    "description": "Book the Best Outstation Taxi Service in Thane with premium vehicles, experienced chauffeurs, affordable fares, and dependable long-distance travel."
  },
  {
    "name": "Best Outstation Taxi Service in Thane Contact Number",
    "description": "Contact our Best Outstation Taxi Service in Thane for instant bookings, transparent pricing, professional drivers, and 24x7 customer assistance."
  },
  {
    "name": "Best Outstation Cab Service in Mumbai",
    "description": "Choose the Best Outstation Cab Service in Mumbai for comfortable intercity travel with fixed fares, AC vehicles, online booking, and experienced chauffeurs."
  },
  {
    "name": "Taxi Service in Thane West",
    "description": "Book Taxi Service in Thane West for local rides, airport transfers, Pune travel, corporate trips, family travel, and outstation journeys with reliable drivers."
  },
  {
    "name": "Thane to Pune Taxi Booking",
    "description": "Complete your Thane to Pune Taxi Booking online with instant confirmation, multiple cab options, transparent fares, and secure reservations."
  },
  {
    "name": "Thane to Pune Drop Taxi",
    "description": "Book Thane to Pune Drop Taxi with punctual pickup, experienced chauffeurs, clean AC cars, and affordable one way travel."
  },
  {
    "name": "Thane to Pune Online Cab Booking",
    "description": "Reserve Thane to Pune Online Cab Booking with instant confirmation, secure payment, multiple vehicle options, and 24x7 availability."
  },
  {
    "name": "Thane to Pune Private Cab",
    "description": "Choose Thane to Pune Private Cab for exclusive chauffeur-driven travel with complete privacy, comfortable seating, and flexible pickup timing."
  },
  {
    "name": "Thane to Pune Outstation Cab",
    "description": "Book Thane to Pune Outstation Cab for safe intercity travel with AC vehicles, fixed fares, experienced drivers, and reliable customer support."
  },
  {
    "name": "Thane to Pune Cheap Cab",
    "description": "Hire Thane to Pune Cheap Cab offering affordable fares, clean vehicles, professional chauffeurs, and comfortable one way or round trip travel."
  },
  {
    "name": "Thane to Pune AC Cab Service",
    "description": "Travel comfortably with Thane to Pune AC Cab Service featuring well-maintained air-conditioned vehicles, transparent pricing, and smooth highway journeys."
  },
  {
    "name": "Thane to Pune Innova Cabs",
    "description": "Book Thane to Pune Innova Cabs for spacious family travel, business meetings, group tours, airport transfers, and luxury intercity transportation."
  },
  {
    "name": "Thane to Pune Taxi Fare",
    "description": "Check Thane to Pune Taxi Fare with fixed pricing, affordable packages, multiple cab choices, and no hidden charges."
  },
  {
    "name": "Thane West to Pune Cab",
    "description": "Reserve Thane West to Pune Cab with professional chauffeurs, AC vehicles, fixed fares, and comfortable outstation travel."
  },
  {
    "name": "Thane East to Pune Cab",
    "description": "Book Thane East to Pune Cab for safe and reliable intercity travel with clean AC vehicles, affordable pricing, and 24x7 service."
  },
  {
    "name": "Thane to Pune Round Trip Cab",
    "description": "Choose Thane to Pune Round Trip Cab with flexible return timing, experienced drivers, premium vehicles, and transparent pricing."
  },
  {
    "name": "Thane to Pune Cab Per Km Rate",
    "description": "Check Thane to Pune Cab Per Km Rate with transparent pricing, affordable packages, and multiple vehicle options for every travel requirement."
  },
  {
    "name": "Thane to Pune Sedan Taxi",
    "description": "Travel with Thane to Pune Sedan Taxi for economical, comfortable, and reliable outstation transportation with professional chauffeurs."
  },
  {
    "name": "Thane to Pune Innova Crysta Cab",
    "description": "Book Thane to Pune Innova Crysta Cab for premium family travel, corporate trips, airport transfers, luxury seating, spacious luggage space, and a comfortable highway journey."
  }
],

"tableData": [
  ["Thane to Pune Cab", "Thane to Pune Taxi"],
  ["Thane to Pune Station Cab Fare", "Thane to Pune One Way Cab"],
  ["Thane to Pune Ertiga Cab", "Thane to Pune One Way Taxi"],
  ["Thane to Pimpri Chinchwad Cab Fare", "Thane to Pune Cab Service"],
  ["Thane to Pune Innova Cab Service", "Mulund to Pune Taxi Fare"],
  ["Cab Service in Thane", "Thane to Pune Round Trip Cab Service"],
  ["Thane to Baner Cab Fare", "Outstation Taxi Service in Thane"],
  ["Best Outstation Taxi Service in Thane", "Best Outstation Taxi Service in Thane Contact Number"],
  ["Best Outstation Cab Service in Mumbai", "Taxi Service in Thane West"],
  ["Thane to Pune Taxi Booking", "Thane to Pune Drop Taxi"],
  ["Thane to Pune Online Cab Booking", "Thane to Pune Private Cab"],
  ["Thane to Pune Outstation Cab", "Thane to Pune Cheap Cab"],
  ["Thane to Pune AC Cab Service", "Thane to Pune Innova Cabs"],
  ["Thane to Pune Taxi Fare", "Thane West to Pune Cab"],
  ["Thane East to Pune Cab", "Thane to Pune Round Trip Cab"],
  ["Thane to Pune Cab Per Km Rate", "Thane to Pune Sedan Taxi"],
  ["Thane to Pune Innova Crysta Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Thane to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Thane to Pune cab services with comfortable vehicles, skilled chauffeurs, and reliable intercity transportation for every travel requirement."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Thane",
    WhyChoosedescription: "Book convenient pickup from Thane West, Thane East, Ghodbunder Road, Majiwada, Wagle Estate, hotels, offices, and residential societies with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Smooth & Safe Highway Journey",
    WhyChoosedescription: "Our experienced drivers ensure a safe and comfortable ride through the Mumbai–Pune Expressway with timely pickups and efficient route planning."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Trip",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to match your travel style, passenger count, and luggage requirements."
  },
  {
    WhyChooseheading: "Competitive Pricing Without Hidden Charges",
    WhyChoosedescription: "Get transparent fare details before booking so you can travel confidently with fair and affordable cab pricing."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Custom Travel",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages designed to fit your personal or business travel schedule."
  },
  {
    WhyChooseheading: "Perfect for Corporate, Airport & Family Travel",
    WhyChoosedescription: "Our Thane to Pune cabs are ideal for business meetings, airport transfers, family vacations, college visits, and weekend getaways."
  },
  {
    WhyChooseheading: "24/7 Booking & Customer Assistance",
    WhyChoosedescription: "Our dedicated support team is available around the clock to assist with bookings, vehicle selection, and travel-related queries."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Thane to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Thane to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Thane to Pune?",
    answer: "Yes, one-way cab services are available with convenient pickup from any location in Thane and direct drop anywhere in Pune."
  },
  {
    question: "Which areas of Thane are covered for pickup?",
    answer: "We provide pickup from Thane West, Thane East, Ghodbunder Road, Majiwada, Wagle Estate, railway stations, hotels, and nearby areas."
  },
  {
    question: "Which vehicles are available for Thane to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Thane to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7, making it convenient to travel according to your preferred schedule."
  },
  {
    question: "Can I book a return cab from Pune to Thane?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Thane."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I reserve my Thane to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup timing."
  },
  {
    question: "Do you provide Thane to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Thane to Pune Cabs with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pranav Kulkarni",
    feedback: "Trustline Travels provided an outstanding Thane to Pune cab experience. The driver arrived on time, the vehicle was clean, and the journey was smooth and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nisha Patwardhan",
    feedback: "From booking to drop-off, everything was handled professionally. The spacious cab, courteous driver, and timely service made our Thane to Pune trip pleasant and completely hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Pune Cabs",
  "image": "https://www.trustlinetravels.com/assets/images/thane-to-pune-cabs.webp",
  "description":
    "Book Thane to Pune Cabs with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cab services from Thane to Pune, Pimpri Chinchwad, Baner, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/thane-to-pune-cabs"
  }
};





  return (
    <div>
<Helmet>
  <title>Thane to Pune Cabs | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Thane to Pune Cabs with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Thane to Pune, Pimpri Chinchwad, Baner, Pune Railway Station, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at affordable fares."
  />

  <meta
    name="keywords"
    content="thane to pune cab, thane to pune taxi, thane to pune station cab fare, thane to pune one way cab, thane to pune ertiga cab, thane to pune one way taxi, thane to pimpri chinchwad cab fare, thane to pune cab service, thane to pune innova cab service, mulund to pune taxi fare, cab service in thane, thane to pune round trip cab service, thane to baner cab fare, Thane to Pune Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Thanetopunecab;